import { Box, Checkbox, FormControlLabel, ListItem, Typography } from '@mui/material';
import { Card } from 'src/components/UI/Card';
import { Controller, useFormContext } from 'react-hook-form';
import { errorMessageSx } from 'src/components/UI/Input.styles';
import {
  termsCheckboxLabelSx,
  termsContainerSx,
  termsDescriptionSx,
  termsHeadingSx,
  termsListItemSx,
  termsListSx
} from '../../styles/createCampaign';
import { ConfirmAndPayFormData } from './index';

const TERMS_AND_CONDITIONS_TEXTS = [
  'All citation submissions will be completed within 7 days of purchase.',
  "You're fully responsible for ensuring all submitted information is accurate before checkout.",
  'Some directories may not display photos, descriptions, or services on business profiles.',
  "We make every effort to remove duplicate listings, but success isn't guaranteed across all sites. [Learn more]",
  'Once your campaign begins, submitted details may not be editable.',
  "If a selected site can't accept your listing, SEOSpace will replace it with a similar, high-authority alternative.",
  'Not every submission results in a live listing — we guarantee at least 70% will go live.'
] as const;

export const TermsNConditions = () => {
  const {
    control,
    formState: { errors }
  } = useFormContext<ConfirmAndPayFormData>();

  return (
    <Card>
      <Typography sx={termsHeadingSx}>Terms & Conditions</Typography>

      <Box sx={termsContainerSx}>
        <Typography sx={termsDescriptionSx}>
          Before completing your purchase, please review and acknowledge the following:
        </Typography>

        <Box component="ul" sx={termsListSx}>
          {TERMS_AND_CONDITIONS_TEXTS.map((text) => (
            <ListItem key={text} component="li" sx={termsListItemSx}>
              {text}
            </ListItem>
          ))}
        </Box>

        <Controller
          name="termsAccepted"
          control={control}
          render={({ field }) => (
            <>
              <FormControlLabel
                sx={termsCheckboxLabelSx}
                control={
                  <Checkbox
                    {...field}
                    checked={field.value || false}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label="I have read and agree to this terms & conditions*"
              />
              {errors.termsAccepted && (
                <Typography sx={errorMessageSx}>
                  {errors.termsAccepted.message as string}
                </Typography>
              )}
            </>
          )}
        />
      </Box>
    </Card>
  );
};
